import { Component, EventEmitter, Output } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { EmailType, IEmailMessageWrite } from '../../models/emailMessage';
import { Person } from 'src/app/people/models/person';
import { CredentialSingletonService } from '../../services/credential-singleton.service';
import { AuthService } from 'src/app/auth/auth.service';

@Component({
  selector: 'credential-pdf-email',
  templateUrl: 'credential-pdf-email.component.html',
  styleUrls: ['credential-pdf-email.component.scss'],
  standalone: false
})
export class CredentialPdfEmailComponent {
  @Output() open = new EventEmitter();
  @Output() close = new EventEmitter();

  credentialPdfEmailForm: FormGroup;
  title = 'Email Credential Certificate PDF';
  loaded = false;
  isEditMode = false;
  emailType = EmailType.WallCertificate;
  person: Person;
  recipientPersonId: string;
  fullName: string;
  email: string;
  personCredentialId: string;

  constructor(
    private credentialSingleton: CredentialSingletonService,
    public authService: AuthService
  ) {}

  get isValid(): boolean {
    return this.credentialPdfEmailForm && this.credentialPdfEmailForm.valid;
  }

  onClose() {
    this.close.emit();
    this.loaded = false;
  }

  onOpen = (credentialId: string, person: Person) => {
    if (!this.authService.adminLevelAccess) {
      this.close.emit();
    }
    const { id, fullName, email } = person;
    this.recipientPersonId = id;
    this.fullName = fullName;
    this.email = email;
    this.person = person;
    this.personCredentialId = credentialId;
    this.isEditMode = true;
    this.open.emit();
    this.loaded = true;
  };

  set saved(value: boolean) {
    if (value) {
      this.onClose();
    }
  }

  onComposeEmailComplete = (form: any) => {
    this.credentialPdfEmailForm = form;
    this.isEditMode = true;
    this.loaded = true;
  };

  onSend = () => {
    if (this.isValid) {
      var message: IEmailMessageWrite = {
        subject: this.credentialPdfEmailForm.get('subject').value,
        senderName: this.credentialPdfEmailForm.get('fromName').value,
        replyTo: this.credentialPdfEmailForm.get('replyTo').value,
        email: this.credentialPdfEmailForm.get('content').value
      };

      this.credentialSingleton
        .sendWallCertificateEmail(this.personCredentialId, message)
        .then(() => {
          this.onClose();
        });
    }
  };
}
